import { IconProps } from "../../utils/global-types/global-types";

const PeopleIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      viewBox="0 0 14 14"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className ? className : "w-4 h-4"}
      {...rest}
    >
      <path
        d="M10.2285 4.53252C10.1877 4.52669 10.1469 4.52669 10.106 4.53252C9.20187 4.50335 8.48438 3.76252 8.48438 2.85252C8.48438 1.92502 9.23688 1.16669 10.1702 1.16669C11.0977 1.16669 11.856 1.91919 11.856 2.85252C11.8502 3.76252 11.1327 4.50335 10.2285 4.53252Z"
        fill="currentColor"
      />
      <path
        d="M12.1239 8.57499C11.4705 9.01249 10.5547 9.17582 9.70885 9.06499C9.93052 8.58666 10.0472 8.05582 10.053 7.49582C10.053 6.91249 9.92469 6.35832 9.67969 5.87416C10.543 5.75749 11.4589 5.92082 12.118 6.35832C13.0397 6.96499 13.0397 7.96249 12.1239 8.57499Z"
        fill="currentColor"
      />
      <path
        d="M3.75448 4.53252C3.79531 4.52669 3.83615 4.52669 3.87698 4.53252C4.78115 4.50335 5.49865 3.76252 5.49865 2.85252C5.49865 1.91919 4.74615 1.16669 3.81281 1.16669C2.88531 1.16669 2.13281 1.91919 2.13281 2.85252C2.13281 3.76252 2.85031 4.50335 3.75448 4.53252Z"
        fill="currentColor"
      />
      <path
        d="M3.82115 7.49581C3.82115 8.06165 3.94365 8.59831 4.16531 9.08248C3.34281 9.16998 2.48531 8.99498 1.85531 8.58081C0.933646 7.96831 0.933646 6.97081 1.85531 6.35831C2.47948 5.93831 3.36031 5.76915 4.18865 5.86248C3.94948 6.35248 3.82115 6.90665 3.82115 7.49581Z"
        fill="currentColor"
      />
      <path
        d="M7.06687 9.2575C7.02021 9.25167 6.96771 9.25167 6.91521 9.2575C5.84187 9.2225 4.98438 8.34167 4.98438 7.25667C4.99021 6.14833 5.88271 5.25 6.99688 5.25C8.10521 5.25 9.00354 6.14833 9.00354 7.25667C8.99771 8.34167 8.14604 9.2225 7.06687 9.2575Z"
        fill="currentColor"
      />
      <path
        d="M5.17625 10.465C4.29542 11.0541 4.29542 12.0225 5.17625 12.6058C6.17958 13.2766 7.82458 13.2766 8.82792 12.6058C9.70875 12.0166 9.70875 11.0483 8.82792 10.465C7.83042 9.79414 6.18542 9.79414 5.17625 10.465Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default PeopleIcon;
